import service from "../request/golbal";

//get
export function getAction(url, data) {
  return service.get(url, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

export function postAction(url, data) {
  return service({
    url: url,
    method: "post",
    data
  });
}

//获取菜单
export function getmenu(data) {
  if (!data.belongSystemId) {
    data.belongSystemId = window.sessionStorage.getItem("menutype");
  }
  return service.post(`/front/menu/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}
// //获取菜单 - 政策法规-伦理
export function getMenu2(data) {
  return service.post(`/front/menu/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询首页banner图
export function bannerQuery(data) {
  if (data.belongSystemId) {
  } else {
    data.belongSystemId = window.sessionStorage.getItem("menutype");
  }

  return service.post(`/front/banner/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//获取新闻通告
export function getnews(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/news/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

// 中心介绍查询
export function centerQuery(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/centerItro/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

// 中心介绍查看
export function centerSee(id) {
  return service({
    url: `/front/centerItro/info/${id}`,
    method: "get"
  });
}

//查询政策法规列表
export function policyQuery(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/policeRegulation/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询GCP专业科室列表
export function GCPQuery(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/gcpDepartment/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询首页通知公告
export function allNewsQuery(data) {
  return service.post(`/front/allNews/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询首页办事指南
export function allGuideQuery(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/allHandleGuide/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询链接管理列表
export function linkQuery(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/tbLink/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询办事指南列表
export function handleGuide(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/handleGuide/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询办事指南列表
export function downloadCenter(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/downloadCenter/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询联系我们列表
export function contacusList(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/contacus/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询联系我们列表
export function adressList(data) {
  data.belongSystemId = window.sessionStorage.getItem("menutype");
  return service.post(`/front/adress/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询home页面伦理委员会重要公告
export function ethicNewsQuery(data) {
  return service.post(`/front/home/ethics/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//伦理培训
export function tbethicstrain(data) {
  return service.post(`/front/tbethicstrain/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//伦理培训
export function tbpatenpromotion(data) {
  return service.post(`/front/tbpatenpromotion/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询专利推介列表
export function patentRecommendation(data) {
  if (!data.belongSystemId) {
    data.belongSystemId = window.sessionStorage.getItem("menutype");
  }
  return service.post(`/front/patenpromotion/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

//查询home页面技术机构转移专利推介
export function patentRecommendationHome(data) {
  return service.post(`/front/home/tbpatenpromotion/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

// 试验项目列表
export function listTbrecruit(data) {
  return service.post(`/index/recruit/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

// 试验项目列表
export function listIndexTbrecruit(data) {
  return service.post(`/index/recruit/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}

// 试验项目详情
export function getTbrecruit(id, path) {
  return service.get(`/front/recruit/info/${id}`, {
    headers: {
      "content-type": "application/json"
    }
  });
}

// 试验项目科室列表
export function getDeptList() {
  return service.get(`/index/recruit/dept-list`, {
    headers: {
      "content-type": "application/json"
    }
  });
}

// 首页查看试验项目详情
export function getRecruitInfo(id) {
  return service.get(`/index/recruit/info/${id}`, {
    headers: {
      "content-type": "application/json"
    }
  });
}
// 获取政策法规文章列表 - 伦理
export function getTbpoliceregulationList(data) {
  return service.post(`/adm/tbpoliceregulation/list`, data, {
    headers: {
      "content-type": "application/json"
    }
  });
}



// WEBPACK FOOTER //
// ./src/request/api.js